import { render, staticRenderFns } from "./drag-box.vue?vue&type=template&id=7abf2a53&scoped=true"
import script from "./drag-box.vue?vue&type=script&lang=js"
export * from "./drag-box.vue?vue&type=script&lang=js"
import style0 from "./drag-box.vue?vue&type=style&index=0&id=7abf2a53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf2a53",
  null
  
)

export default component.exports